import { render, staticRenderFns } from "./TotalScannedProductsIndicator.vue?vue&type=template&id=59cc1c98&scoped=true"
import script from "./TotalScannedProductsIndicator.vue?vue&type=script&lang=js"
export * from "./TotalScannedProductsIndicator.vue?vue&type=script&lang=js"
import style0 from "./TotalScannedProductsIndicator.vue?vue&type=style&index=0&id=59cc1c98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cc1c98",
  null
  
)

export default component.exports